export default {
  /**
   * 验证邮箱
   * @param str
   */
  email(str) {
    const regExp = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
    if (regExp.test(str)) {
      return true
    } else {
      return false
    }
  }
}
